import { media } from "@features/adaptive/breakpoints";

import styled from "styled-components";

export const StyledProductPhotoGallery = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;

  gap: 18px;
  ${media.down("desktop")} {
    gap: 6px;
  }
`;

export const StyledMainImageContainer = styled.div`
  max-width: 440px;

  ${media.down("desktop")} {
    order: 0;
  }
`;
